import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, CircularProgress, Dialog, DialogContent, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import {
	modalPapel,
	modalHero,
	modalHeroLinha,
	modalHeroIcone,
	modalHeroEtiqueta,
	modalHeroTitulo,
	modalHeroSub,
	modalFechar,
	modalCorpo,
	modalRodape,
	botaoPrimario,
	botaoSecundario,
	botaoPerigoCheio
} from "../../utils/estiloNavy";

// Confirmacao no padrao visual do sistema (no lugar do alert do navegador).
//   itens: [{ icone, titulo, texto }]  -> lista de pontos explicados
//   perigo: botao de confirmar vermelho

const useStyles = makeStyles(theme => {
	const dark = theme.palette.type === "dark";
	return {
		paper: modalPapel(theme, 520),
		hero: modalHero(theme),
		heroLinha: modalHeroLinha,
		heroIcone: modalHeroIcone,
		heroIconePerigo: { ...modalHeroIcone, background: "linear-gradient(135deg, #f87171, #dc2626)" },
		etiqueta: modalHeroEtiqueta,
		titulo: { ...modalHeroTitulo, whiteSpace: "normal" },
		sub: modalHeroSub,
		fechar: { ...modalFechar, marginLeft: "auto", alignSelf: "flex-start" },
		corpo: modalCorpo(theme),
		item: {
			display: "flex",
			gap: 12,
			alignItems: "flex-start",
			padding: "12px 14px",
			borderRadius: 14,
			backgroundColor: dark ? "rgba(255,255,255,0.04)" : "#fff",
			border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.07)"}`
		},
		itemIcone: {
			width: 32,
			height: 32,
			borderRadius: 10,
			flexShrink: 0,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontSize: 17,
			backgroundColor: dark ? "rgba(52,211,153,0.12)" : "rgba(30,152,85,0.1)"
		},
		itemTitulo: { fontSize: "0.86rem", fontWeight: 800, color: theme.palette.text.primary },
		itemTexto: { fontSize: "0.8rem", color: theme.palette.text.secondary, lineHeight: 1.45, marginTop: 2 },
		rodape: { ...modalRodape(theme), justifyContent: "flex-end" },
		primario: botaoPrimario,
		perigo: botaoPerigoCheio,
		secundario: botaoSecundario(theme)
	};
});

const ConfirmarAcaoModal = ({
	open,
	onClose,
	onConfirm,
	icone,
	etiqueta,
	titulo,
	subtitulo,
	itens = [],
	textoConfirmar = "Confirmar",
	perigo = false,
	carregando = false
}) => {
	const classes = useStyles();
	return (
		<Dialog open={open} onClose={carregando ? undefined : onClose} maxWidth={false} classes={{ paper: classes.paper }}>
			<div className={classes.hero}>
				<div className={classes.heroLinha}>
					{icone && <div className={perigo ? classes.heroIconePerigo : classes.heroIcone}>{icone}</div>}
					<div style={{ minWidth: 0 }}>
						{etiqueta && <div className={classes.etiqueta}>{etiqueta}</div>}
						<div className={classes.titulo}>{titulo}</div>
						{subtitulo && <div className={classes.sub}>{subtitulo}</div>}
					</div>
					<IconButton size="small" onClick={onClose} disabled={carregando} className={classes.fechar}>
						<Close fontSize="small" />
					</IconButton>
				</div>
			</div>
			{itens.length > 0 && (
				<DialogContent className={classes.corpo}>
					{itens.map((it, i) => (
						<div key={i} className={classes.item}>
							<div className={classes.itemIcone}>{it.icone}</div>
							<div>
								<div className={classes.itemTitulo}>{it.titulo}</div>
								{it.texto && <div className={classes.itemTexto}>{it.texto}</div>}
							</div>
						</div>
					))}
				</DialogContent>
			)}
			<div className={classes.rodape}>
				<Button className={classes.secundario} onClick={onClose} disabled={carregando}>
					Cancelar
				</Button>
				<Button className={perigo ? classes.perigo : classes.primario} onClick={onConfirm} disabled={carregando}>
					{carregando ? <CircularProgress size={18} style={{ color: "#fff" }} /> : textoConfirmar}
				</Button>
			</div>
		</Dialog>
	);
};

export default ConfirmarAcaoModal;
